
import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject} from 'rxjs';

import {distinctUntilChanged, debounceTime,  map } from 'rxjs/operators';
import {Component , ElementRef , OnInit , ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {OrganizationTypeService} from '../../../../core/services/organizationType.service';
import {DataSource} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';



import {FuseUtils} from '../../../../core/fuseUtils';
import {FormGroup} from '@angular/forms';
import {FunctionFormDialogComponent } from './setting-form/setting-form.component';
import {FuncionTypeService} from '../../../../core/services/functionType.service';

@Component({
    selector: 'function-settings-page',
    templateUrl: './function-settings.component.html',
    styleUrls: ['./function-settings.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class FunctionSettingsComponent implements OnInit {
  functionTypes: FilesDataSource | null;
  displayedColumns = [ 'name', 'rate' ];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  dialogRef: any;

  constructor (private http: HttpClient , private functionTypesService: FuncionTypeService , public dialog: MatDialog,  public snackBar: MatSnackBar ) {
  }

  ngOnInit () {
    this.getDataType();
  }

  getDataType () {
    this.functionTypes = new FilesDataSource(this.functionTypesService , this.paginator , this.sort);
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.functionTypes) {
          return;
        }
        this.functionTypes.filter = this.filter.nativeElement.value;
      });
  }

  newType () {
    this.dialogRef = this.dialog.open(FunctionFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '400px',
      data: {
        action: 'new'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: FormGroup) => {
        const data = response.value;
        this.functionTypesService.addFunctionType(data).subscribe((res) => {
          if (res) {
            this.snackBar.open('Function added.', '', {duration: 2500});
            this.functionTypesService.getFunctionTypes().then();
          }
        }, error => {
          this.snackBar.open('Add failed.', '', {duration: 2500});
        } );
      });

  }


  editType (type) {
    this.dialogRef = this.dialog.open(FunctionFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '400px',
      data: {
        type: type ,
        action: 'edit'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        console.log(response);
        const actionType: string = response[ 0 ];
        const data = response[ 1 ].value;
        data.id = type.id;
        switch (actionType) {
          /**
           * Save
           */
          case 'save':


            this.functionTypesService.addFunctionType(data).subscribe((res) => {
              if (res) {
                this.snackBar.open('Function updated.', '', {duration: 2500});
                this.functionTypesService.getFunctionTypes().then();
              }
            }, error => {
              this.snackBar.open('Update failed.', '', {duration: 2500});
            });
            break;
          /**
           * Delete
           */
          case 'delete':
            this.functionTypesService.deleteFunctionType(type.id).subscribe((res) => {
              if (res) {
                this.snackBar.open('Function deleted.', '', {duration: 2500});
                this.functionTypesService.getFunctionTypes().then();
              }
            }, error => {
              this.snackBar.open('Delete failed.', '', {duration: 2500});
            });

            break;
        }
      });
  }
}

export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private cantonsService: FuncionTypeService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.cantonsService.functionTypes;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.cantonsService.onFunctionTypeChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.cantonsService.functionTypes.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'name':
          [ propertyA , propertyB ] = [ a.name , b.name ];
          break;
          case 'rate':
          [ propertyA , propertyB ] = [ a.rate , b.rate ];
          break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
